import { createRouter, createWebHistory } from "vue-router";
import pathsNL from "@/router/routes/routesNL.js";
import pathsEN from "@/router/routes/routesEN.js";

let routes = [
  {
    path: "/about",
    name: "About",
    lang: "nl-NL",
    component: () => import("@/devtools/About.vue"),
  },
  {
    path: "/Rework",
    name: "Rework",
    lang: "nl-NL",
    component: () => import("@/devtools/ReworkJson.vue"),
  },
  {
    path: "/Compare",
    name: "Compare",
    lang: "nl-NL",
    component: () => import("@/devtools/CompareJson.vue"),
  },
  {
    path: "/Modify",
    name: "Modify",
    lang: "nl-NL",
    component: () => import("@/devtools/Modify.vue"),
  },
  {
    path: "/Data",
    name: "Data",
    lang: "nl-NL",
    component: () => import("@/devtools/CopyData.vue"),
  },
  {
    path: "/Copy",
    name: "Copy",
    lang: "nl-NL",
    component: () => import("@/devtools/CopyJson.vue"),
  },
];

for (const vue in pathsNL) {
  routes = [...routes, ...pathsNL[vue]];
}

for (const vue in pathsEN) {
  routes = [...routes, ...pathsEN[vue]];
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
